module.exports = __webpack_public_path__ + "static/media/service_profit.d3a85a70.png";